import React from "react";
import PropTypes from "prop-types";

import { NavLink } from "react-router-dom";
// MUI
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@material-ui/core";

const NavItem = ({ className, title, path, icon: Icon, func }) => {
  return (
    <ListItem
      button
      className={className}
      component={NavLink}
      exact
      to={path}
      onClick={() => func(title)}
    >
      <Tooltip title={title}>
        <ListItemIcon>
          <Icon color="primary" />
        </ListItemIcon>
      </Tooltip>
      <ListItemText primary={title} />
    </ListItem>
  );
};

NavItem.propTypes = {
  className: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  func: PropTypes.func.isRequired,
};

export default React.memo(NavItem);
